/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Endpoint_Provider_Not_ServingInputs */

const en_endpoint_provider_not_serving = /** @type {(inputs: Endpoint_Provider_Not_ServingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Not serving`)
};

const zh_hans1_endpoint_provider_not_serving = /** @type {(inputs: Endpoint_Provider_Not_ServingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`暂停服务`)
};

const pt_br2_endpoint_provider_not_serving = /** @type {(inputs: Endpoint_Provider_Not_ServingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fora de serviço`)
};

const es_endpoint_provider_not_serving = /** @type {(inputs: Endpoint_Provider_Not_ServingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fuera de servicio`)
};

const fr_endpoint_provider_not_serving = /** @type {(inputs: Endpoint_Provider_Not_ServingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hors service`)
};

const de_endpoint_provider_not_serving = /** @type {(inputs: Endpoint_Provider_Not_ServingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nicht aktiv`)
};

const ru_endpoint_provider_not_serving = /** @type {(inputs: Endpoint_Provider_Not_ServingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Не обслуживает`)
};

const it_endpoint_provider_not_serving = /** @type {(inputs: Endpoint_Provider_Not_ServingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non attivo`)
};

/**
* | output |
* | --- |
* | "Not serving" |
*
* @param {Endpoint_Provider_Not_ServingInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const endpoint_provider_not_serving = /** @type {((inputs?: Endpoint_Provider_Not_ServingInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Endpoint_Provider_Not_ServingInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_endpoint_provider_not_serving(inputs)
	if (locale === "pt-BR") return pt_br2_endpoint_provider_not_serving(inputs)
	if (locale === "es") return es_endpoint_provider_not_serving(inputs)
	if (locale === "fr") return fr_endpoint_provider_not_serving(inputs)
	if (locale === "de") return de_endpoint_provider_not_serving(inputs)
	if (locale === "ru") return ru_endpoint_provider_not_serving(inputs)
	if (locale === "it") return it_endpoint_provider_not_serving(inputs)
	return en_endpoint_provider_not_serving(inputs)
});